import { AppSettingsService } from '../appSettingsService';
import { AuthService } from '../auth/authService';
import { IItemAuditDataProvider } from './auditDataProvider';
import { AuditObjectFilter } from './auditObjectFilter';
import { AuditService } from './baseAuditService';
import { IEnvironmentAuditDataProvider } from './environmentAuditDataProvider';

export class FortraDlpAnalyticsAuditService extends AuditService {
    public static readonly policyManagerLoggerName = 'Fortra DLP Analytics and Reporting';
    private eventCollectorEndpoint: string;

    constructor(
        eventCollectorEndpoint: string,
        authService: AuthService,
        appSettingsService: AppSettingsService,
        environmentInfoProvider: IEnvironmentAuditDataProvider,
        auditDataProvider: IItemAuditDataProvider,
        auditObjectFilter: AuditObjectFilter,
    ) {
        super(authService, appSettingsService, environmentInfoProvider, auditDataProvider, auditObjectFilter);

        this.eventCollectorEndpoint = eventCollectorEndpoint;
    }

    protected async submitEvent(payload: string): Promise<boolean> {
        try {
            const token = this.authService.getCachedTitusToken();

            const response = await fetch(this.eventCollectorEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: payload,
            });

            if (!response.ok) {
                console.warn('Audit POST failed:', response.status, response.statusText);
                return false;
            }

            return true;
        } catch (error) {
            console.warn('Audit POST error:', error);
            return false;
        }
    }
}
